import {
  AdminUnitDepartments,
  AdminUnitDetail,
  ChildOrgUnit,
  Structure,
} from "types";
import apiClient from "../lib/apiClients";

// departments_by_admin_unit:
export const fetchDepartmentsByAdminUnit = async (
  adminUnitId: number | string
) => {
  const response = await apiClient.get<any[]>(
    `/complaint_entity/complaints/departments_by_admin_unit/?admin_unit_uuid=${adminUnitId}`
  );
  return response.data;
};

// child_org_units:
export const fetchChildOrgUnits = async (parentOrgUnitId: number | string) => {
  const response = await apiClient.get<ChildOrgUnit>(
    `/complaint_entity/complaints/child_org_units/?parent_org_unit_uuid=${parentOrgUnitId}`
  );
  return response.data;
};

// admin_unit_detail:
export const fetchAdminUnitDetail = async (adminUnitId: number | string) => {
  const response = await apiClient.get<AdminUnitDetail>(
    `/complaint_entity/complaints/admin_unit_detail/?admin_unit_uuid=${adminUnitId}`
  );
  return response.data;
};

// to get department for a given admin unit
export const fetchDepartmentsForAdminUnit = async (
  adminUnitId: number | string
) => {
  const response = await apiClient.get<AdminUnitDepartments>(
    `/complaint_entity/complaints/admin-unit-departments/${adminUnitId}/`
  );
  return response.data;
};

// Child Departments Endpoint:
export const fetchChildDepartments = async (parentId: number | string) => {
  const response = await apiClient.get<any[]>(
    `/complaint_entity/complaints/child-departments/${parentId}/`
  );
  return response.data;
};

export const adminOrgStructure = async (
  adminId: number | string,
  orgId: number | string
) => {
  const response = await apiClient.get<Structure>(
    `/complaint_entity/complaints/user-org-details/?admin_unit_uuid=${adminId}&org_unit_uuid=${orgId}`
  );
  return response.data;
};
